/* eslint-disable camelcase */
import { observable, computed } from 'mobx';
import { DateTime } from 'luxon';

type SessionOffering = {
  start_time?: string;
};

class DashboardStore {
  @observable data: Record<string, unknown> | undefined = undefined;

  @observable userSubscription: Record<string, unknown> = {};

  @observable timeDifference = 61;

  @observable title = '';

  @observable isLessThanAnHour = false;

  @observable offering: SessionOffering | undefined = undefined;

  @computed get countDown() {
    const now = DateTime.now();
    const start = DateTime.fromISO(this.offering?.start_time ?? '');

    this.timeDifference = start.diff(now, 'minutes').minutes;

    if (this.timeDifference < 61 && this.timeDifference > 0) {
      this.isLessThanAnHour = true;
    }

    return this.timeDifference;
  }
}

export default DashboardStore;
